module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('sidebar', {
    staticClass: "sidebar--student",
    attrs: {
      "user": _vm.user,
      "disableUserMenu": _vm.isInspecting,
      "showOptions": false,
      "isLoading": _vm.loading
    }
  }, [_c('accordion', {
    staticClass: "accordion--workspace",
    attrs: {
      "collections": _vm.groupTerms,
      "initialExpanded": _vm.expandedGroupTerm,
      "isLoading": _vm.isLoadingGroupTerm
    },
    on: {
      "expanded": function($event) {
        _vm.expandedGroupTerm = $event.id
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(groupTerm) {
        return [(groupTerm.id != -1) ? _c('timeline', {
          attrs: {
            "items": _vm.progressions,
            "isActive": _vm.isAssignmentActive
          },
          on: {
            "click": _vm.viewAssignment
          },
          scopedSlots: _vm._u([{
            key: "item",
            fn: function(progress) {
              return [_c('assignment', {
                attrs: {
                  "progress": progress,
                  "isActive": _vm.isAssignmentActive(progress)
                }
              })]
            }
          }])
        }, [_c('template', {
          slot: "empty"
        }, [(groupTerm.isFirst) ? _c('span', [_vm._v("Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan. ")]) : _vm._e(), _vm._v("Kies een opdracht om aan je werkmap toe te voegen.\n                ")])], 2) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1cc8ec6","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/sidebar/SidebarWorkspace.vue
// module id = 0g7W
// module chunks = 1